// Vue
import { Component, Prop, Vue } from "vue-property-decorator";
// Template
import template from "./template.vue";
import { Module } from "#/components/module/Module";
import { EditWrapper } from "#/components/edit_wrapper/EditWrapper";
import ModuleBase from "#/common/ModuleBase";
import { v4 as uuidv4 } from "uuid";

@Component({
  mixins: [template],
  components: {
    Module,
    EditWrapper,
  },
})
export class ModuleList extends Vue {
  @Prop({ default: false })
  public isInEditMode!: boolean;

  @Prop({ default: () => [] })
  public modules!: Array<Object>;

  get modulesWithHash() {
    return this.modules.map((module) => {
      return {
        ...module,
        __hash: uuidv4(),
      };
    });
  }

  @Prop({ default: "de" })
  public lang!: string;

  @Prop({ default: "GLOBAL" })
  public country!: string;

  @Prop({ default: "auto" })
  public forceBackground!: string;
}
